import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Landing,
  Unavailable,
  Completed,
  RetryError,
  InternalError,
} from './PanelContent';
import LoadingModal from '../../../LoadingModal';
import NetworkIssuesService from '../../../../services/NetworkIssues';
import { GoogleTagManager } from '../../../../helpers';
import NetworkIssuesContext from '../../../../contextProvider/NetworkIssuesContext';

const OtaRefreshStage = ({ available, closePanel, warning }) => {
  const [refreshing, setRefreshing] = useState(false);
  const [errors, setErrors] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const { completeStage1 } = useContext(NetworkIssuesContext);

  const refresh = () => {
    setRefreshing(true);
    NetworkIssuesService.patchRefresh()
      .then(() => {
        setIsCompleted(true);
        setRefreshing(false);
        setErrors(0);
      })
      .catch(() => {
        GoogleTagManager.pushToDataLayer({
          event: 'pagina-virtual',
          page: '/ayuda/problemas-red/modal-reinicio-red/error-conversion',
          pageName: 'Problemas de Red - Reinicio de red - Error Conversión',
        });
        setErrors(prev => prev + 1);
        setRefreshing(false);
      });
  };

  useEffect(() => {
    if (isCompleted) completeStage1();
  }, [isCompleted]);

  const Content = (() => {
    if (errors > 2) return <InternalError />;
    if (errors) return <RetryError retry={refresh} close={closePanel} />;
    if (isCompleted) return <Completed close={closePanel} warning={warning} />;
    if (available)
      return <Landing refresh={refresh} close={closePanel} warning={warning} />;
    return <Unavailable close={closePanel} />;
  })();

  return (
    <>
      {refreshing && <LoadingModal title="Reiniciando señal" />}
      {Content}
    </>
  );
};

OtaRefreshStage.propTypes = {
  available: PropTypes.bool.isRequired,
  closePanel: PropTypes.func.isRequired,
  warning: PropTypes.node,
};

OtaRefreshStage.defaultProps = {
  warning: null,
};

export default OtaRefreshStage;
